@if (formGroup != null) {
  <ng-container [formGroup]="formGroup">
    @for (equipment of equipments; track equipment; let i = $index) {
      <div>
        <sc-checkbox-field formControlName="cb-{{equipment.id}}" labelDictionaryKey="dd.SUPPLEMENTARYEQUIPMENT.{{equipment.id}}.name"></sc-checkbox-field>
      </div>
    }
    @if (!equipments || equipments.length === 0) {
      <div>
        <sc-dictionary-label dictionaryKey="tmc-common.ui.filter-admin.condition.has-supplementary-equipment.no-equipment-defined"></sc-dictionary-label>
      </div>
    }
  </ng-container>
}
